<template>
  <div>
    <input hidden type="file" ref="newAvatarInput" accept="image/*">
    <CModal
      title=""
      color="dark"
      :show.sync="confirmationModal"
      :centered="true"
      :closeOnBackdrop="false"
      :backdrop="true" >
      <template v-slot:header>
        <h4>Actualizaci&oacute;n de imagen</h4>
      </template>
      <template v-slot:body-wrapper>
        <CContainer align="center" class="p-4">
          <div class="c-avatar c-avatar-stack c-avatar-xxl">
            <img v-if="img" :src="img" block class="c-avatar-img"/>
          </div>                   
          <p>¿Desea actualizar con esta imagen?</p>
        </CContainer>
      </template>
      <template v-slot:footer>
        <CContainer  align="center">
          <CButton
            color="success"
            class="mr-2 d-inline-block"
            v-on:click.stop.prevent="updateImg($event)">
            <i class="bi bi-check-circle h5 mr-2"></i>
            Actualizar
          </CButton>
          <CButton
            color="danger"
            variant="outline"
            class="mr-2 d-inline-block"
            @click="confirmationModal=false">
            <i class="bi bi-x-circle h5 mr-2"></i>
            <span>Cancelar</span>
          </CButton>
        </CContainer>
      </template>
    </CModal>
  </div>
</template>
<script>
import { toBase64 } from '../../general'
import mime_types from '../../mime_types.json'

export default {
  data() {
    return {
      img: '',
      imgb64: '',
      fileName: '',
      sizeImage: 0,
      confirmationModal: false
    }
  },
  props: {
    api: Function,
    parentId: String
  },
  mounted() {
    this.$refs.newAvatarInput.addEventListener('click', e => {
      e.stopPropagation()
    })
    this.$refs.newAvatarInput.addEventListener('change', async (e)=> {
      console.log('changed: ', e.target)
      console.log(e.target.files[0].size);

      this.fileName = e.target.files[0].name
      this.sizeImage = e.target.files[0].size

      if (this.sizeImage > 524288) {
        this.$store.commit("setAlert", {
          color: "danger",
          message: "Los archivos no pueden ser de mas de 512Kb de tamaño!",
          show: 5
        })

        return
      }

      const fileExtention = '.' + this.fileName.split('.').at(-1)
      const mimeType = mime_types.find(mime_type => mime_type.extention === fileExtention)

      if(mimeType.mime_type !== 'image/jpeg' && mimeType.mime_type !== 'image/png') {
        this.$store.commit('setAlert', {
          color: "danger",
          message: "Solo se aceptan archivos JPEG o PNG",
          show: 5
        })

        return
      }

      this.imgb64 = await toBase64(e.target.files)
      this.confirmationModal = true
      this.img = `data:${mimeType};base64,${this.imgb64}`
    })
  },
  created() {
    this.$emit('handler', this.openFileBrowser)
  },
  methods: {
    onChangeInputFile(element) {
      console.log(element)
    },
    async updateImg(e){
      e.stopPropagation()
      this.confirmationModal = false
      await this.api(
        this.parentId,
        this.fileName,
        this.imgb64
      )
    //   this.$emit('handler', this.openFileBrowser)
    },
    openFileBrowser() {
      this.$refs.newAvatarInput.click()      
    }
  },
}
</script>